import { css } from 'styled-components';

import roundToPrecision from '../utils/roundToPrecision';

export const colors = {
  black: '#000000',
  brightBlue: '#34ADDD',
  brightRed: '#FF1A1A',
  darkGrayishBlue: '#434C59',
  darkModerateBlue: '#394DAB',
  grayishBlue: '#95A1B4',
  lightGray: '#D8D8D8',
  lightGrayishBlue: '#DAE0F3',
  lightBlue: '#2386ccff',
  lightOrange: '#FF924C',
  lightlyDesaturatedBlue: '#6070B9',
  limeGreen: '#45DA9B',
  mostlyBlack: '#28303B',
  mostlyWhite: '#F9FAFF',
  softBlue: '#536BDD',
  softOrange: '#FE935B',
  softPink: '#F367C1',
  softRed: '#ED5D5A',
  softPurple: '#9370DB',
  softYellow: '#FACD58',
  softBrown: '#D2B48C',
  veryDarkGray: '#424242',
  veryDarkGrayishBlue: '#303A48',
  veryLightGrayishBlue: '#C1C8DA',
  veryPaleBlue: '#EEF2FF',
  verySoftBlue: '#F9FAFF',
  white: '#FFFFFF',
};


export const groupedColors = [
   {
    groupName: 'Sem alteração',
    groupKey: 'noChanges',
    type: 'RX',
    items: [
      {
        key: 'Normal',
        color: '#536BDD',
        valorRoi: 79,
        id: 76,
      },
    ],
  },
  {
    groupName: 'Padrão de Atenuação',
    groupKey: 'attenuationPattern',
    type: 'CT',
    items: [
      {
        key: 'normal',
        color: '#536BDD',
        valorRoi: 1,
        id: 1,
      },
      {
        key: 'high',
        color: '#FACD58',
        valorRoi: 2,
        id: 2,
      },
      {
        key: 'low',
        color: '#ED5D5A',
        valorRoi: 6,
        id: 3,
      }
    ],
  },
  {
    groupName: 'Doença',
    groupKey: 'disease',
    type: 'CT',
    items: [
      {
        key: 'subpleural',
        color: '#F367C1',
        valorRoi: 7,
        id: 4,
      },
      {
        key: 'reticular',
        color: '#FE935B',
        valorRoi: 8,
        id: 5,
      },
      {
        key: 'nodular',
        color: '#D8D8D8',
        valorRoi: 9,
        id: 6,
      },
      {
        key: 'ground',
        color: '#45DA9B',
        valorRoi: 10,
        id: 7,
      },
      {
        key: 'honeycombing',
        color: '#663300',
        valorRoi: 11,
        id: 8,
      },
      {
        key: 'centrilobular',
        color: '#DDA0DD',
        valorRoi: 12,
        id: 9,
      },
      {
        key: 'linear',
        color: '#808000',
        valorRoi: 14,
        id: 11,
      },
      {
        key: 'cyst',
        color: '#66CDAA',
        valorRoi: 15,
        id: 12,
      },
      {
        key: 'fibronodular',
        color: '#191970',
        valorRoi: 16,
        id: 13,
      },
      {
        key: 'crazy',
        color: '#2F4F4F',
        valorRoi: 17,
        id: 14,
      },
      {
        key: 'consolidation',
        color: '#800000',
        valorRoi: 18,
        id: 15,
      },
      {
        key: 'bronchiectasis',
        color: '#F08080',
        valorRoi: 19,
        id: 16,
      },
      {
        key: 'bronchiolectasis',
        color: '#FF7F50',
        valorRoi: 20,
        id: 17,
      },
      {
        key: 'pulmonarycavitation',
        color: '#32CD32',
        valorRoi: 50,
        id: 47,
      },
    ],
  },
  {
    groupName: 'Achados na Tomografia de Tórax em Idosos',
    groupKey: 'findingsChestCTElderly',
    type: 'CT',
    items: [
      {
        key: 'basal',
        color: '#FF6347',
        valorRoi: 22,
        id: 19,
      },
      {
        key: 'thickening',
        color: '#556B2F',
        valorRoi: 23,
        id: 20,
      },
      {
        key: 'dorsalgroundglass',
        color: '#6495ED',
        valorRoi: 24,
        id: 21,
      },
      {
        key: 'periosteofitary',
        color: '#483D8B',
        valorRoi: 25,
        id: 22,
      },
      {
        key: 'thincysts',
        color: '#FFB6C1',
        valorRoi: 26,
        id: 23,
      },
      {
        key: 'bronchial',
        color: '#CD5C5C',
        valorRoi: 27,
        id: 24,
      },
      {
        key: 'bronchialdilation',
        color: '#3CB371',
        valorRoi: 28,
        id: 25,
      },
      {
        key: 'tracheobronchialcalcifications',
        color: '#F4A460',
        valorRoi: 29,
        id: 26,
      },
      {
        key: 'fibrostreaks',
        color: '#4B0082',
        valorRoi: 30,
        id: 27,
      },
      {
        key: 'subsegmentalatelectasis',
        color: '#FFA07A',
        valorRoi: 31,
        id: 28,
      },
      {
        key: 'centrilobularemphysema',
        color: '#EEE8AA',
        valorRoi: 32,
        id: 29,
      },
      {
        key: 'paraseptalemphysema',
        color: '#40E0D0',
        valorRoi: 52,
        id: 49,
      },
      {
        key: 'subpleuralemphysema',
        color: '#9370DB',
        valorRoi: 53,
        id: 50,
      },
      {
        key: 'parenchymalbands',
        color: '#228b22',
        valorRoi: 33,
        id: 30,
      },
      {
        key: 'smallernodules',
        color: '#FF69B4',
        valorRoi: 34,
        id: 31,
      },
      {
        key: 'largernodules',
        color: '#FF4500',
        valorRoi: 35,
        id: 32,
      },
      {
        key: 'granulomas',
        color: '#808080',
        valorRoi: 36,
        id: 33,
      },
      {
        key: 'pleuralthickening',
        color: '#9932CC',
        valorRoi: 37,
        id: 34,
      },
      {
        key: 'pleuralplaques',
        color: '#D2B48C',
        valorRoi: 38,
        id: 35,
      },
      {
        key: 'pleuraleffusion',
        color: '#4682B4',
        valorRoi: 39,
        id: 36,
      },
      {
        key: 'diaphragmatichernia',
        color: '#008080',
        valorRoi: 40,
        id: 37,
      },
      {
        key: 'diaphragmaticfolds',
        color: '#A0522D',
        valorRoi: 41,
        id: 38,
      },
    ],
  },
  {
    groupName: 'Rastreio oportunístico na Tomografia de Tórax',
    groupKey: 'opportunisticScreeningChestCT',
    type: 'CT',
    items: [
      {
        key: 'ascendingaortadilation',
        color: '#E9967A',
        valorRoi: 42,
        id: 39,
      },
      {
        key: 'ascendingaortacalcifications',
        color: '#0080FF',
        valorRoi: 43,
        id: 40,
      },
      {
        key: 'descendingaortacalcifications',
        color: '#6495ED',
        valorRoi: 44,
        id: 41,
      },
      {
        key: 'coronary',
        color: '#FFE4E1',
        valorRoi: 45,
        id: 42,
      },
      {
        key: 'dorsal',
        color: '#2F4F4F',
        valorRoi: 46,
        id: 43,
      },
      {
        key: 'osteoporosis',
        color: '#D4AF37',
        valorRoi: 13,
        id: 10,
      },
      {
        key: 'myosteatosis',
        color: '#6b3fa0',
        valorRoi: 21,
        id: 18,
      },
      {
        key: 'hepatic',
        color: '#6B8E23',
        valorRoi: 47,
        id: 44,
      },
      {
        key: 'hepatomegaly',
        color: '#CD853F',
        valorRoi: 48,
        id: 45,
      },
      {
        key: 'splenomegaly',
        color: '#483D8B',
        valorRoi: 49,
        id: 46,
      },
      {
        key: 'deformity',
        color: '#FF1493',
        valorRoi: 51,
        id: 48,
      }
    ],
  },
  {
    groupName: 'Tipo predominante de infiltrado',
    groupKey: 'predominantInfiltrateType',
    type: 'RX',
    items: [
      {
        key: 'heterogenousopacity',
        color: '#8B4513',
        valorRoi: 54,
        id: 51,
      },
      {
        key: 'homogeneousopacitywithoutaerobroncogram',
        color: '#B8860B',
        valorRoi: 55,
        id: 52,
      },
      {
        key: 'opacitywithaerobroncogram',
        color: '#CD661D',
        valorRoi: 56,
        id: 53,
      },
      {
        key: 'cavitation',
        color: '#B22234',
        valorRoi: 57,
        id: 54,
      },
      {
        key: 'diffusereticularnodularinfiltrate',
        color: '#6B8E23',
        valorRoi: 58,
        id: 55,
      },
      {
        key: 'localizedreticularnodularinfiltrate',
        color: '#8FBC8F',
        valorRoi: 59,
        id: 56,
      },
      {
        key: 'reticularinterstitialinfiltrate',
        color: '#4682B4',
        valorRoi: 60,
        id: 57,
      },
      {
        key: 'singlecalcifiednodule',
        color: '#DC143C',
        valorRoi: 61,
        id: 58,
      },
      {
        key: 'singlenoncalcifiednodule',
        color: '#FF1493',
        valorRoi: 62,
        id: 59,
      },
      {
        key: 'smallnodules',
        color: '#FF6347',
        valorRoi: 63,
        id: 60,
      },
      {
        key: 'structuralchangesretractiveaspatct',
        color: '#4B0082',
        valorRoi: 64,
        id: 61,
      },
      {
        key: 'bullae',
        color: '#7FFFD4',
        valorRoi: 65,
        id: 62,
      },
      {
        key: 'fibroatelectasis',
        color: '#A9A9A9',
        valorRoi: 66,
        id: 63,
      },
      {
        key: 'segmentalatelectasis',
        color: '#00CED1',
        valorRoi: 76,
        id: 73,
      },
      {
        key: 'subsegmentalatelectasis',
        color: '#8A2BE2',
        valorRoi: 77,
        id: 74,
      },
      {
        key: 'laminaratelectasis',
        color: '#2E8B57',
        valorRoi: 78,
        id: 75,
      },
    ],
  },
  {
    groupName: 'Comprometimento pleural',
    groupKey: 'pleuralCompromise',
    type: 'RX',
    items: [
      {
        key: 'pleuraleffusionuptofiventhrib',
        color: '#4169E1',
        valorRoi: 67,
        id: 64,
      },
      {
        key: 'pleuraleffusionuptothirdrib',
        color: '#1E90FF',
        valorRoi: 68,
        id: 65,
      },
      {
        key: 'pleuraleffusionabovethirdrib',
        color: '#00BFFF',
        valorRoi: 69,
        id: 66,
      },
      {
        key: 'obscurationofcostophrenicsinus',
        color: '#B0C4DE',
        valorRoi: 70,
        id: 67,
      },
      {
        key: 'pleuralthickening',
        color: '#C0C0C0',
        valorRoi: 71,
        id: 68,
      },
    ],
  },
  {
    groupName: 'Lesões',
    groupKey: 'lesions',
    type: 'RX',
    items: [
      {
        key: 'militarytuberculosis',
        color: '#B22222',
        valorRoi: 72,
        id: 69,
      },
      {
        key: 'pericardialeffusion',
        color: '#DC143C',
        valorRoi: 73,
        id: 70,
      },
    ],
  },
  {
    groupName: 'Linfoadenopatia',
    groupKey: 'lymphadenopathy',
    type: 'RX',
    items: [
      {
        key: 'hilarlymphadenopathy',
        color: '#FFA500',
        valorRoi: 74,
        id: 71,
      },
      {
        key: 'mediastinallymphadenopathy',
        color: '#FFa500',
        valorRoi: 75,
        id: 72,
      },
    ],
  },
];


export const windowLevelWidthOptions = [
  {
    id: 1,
    name: 'preset_lungs1',
    windowWidth: 1600,
    windowLevel: -400,
  },
  {
    id: 2,
    name: 'preset_lungs2',
    windowWidth: 1500,
    windowLevel: -600,
  },
  {
    id: 3,
    name: 'preset_mediastinum',
    windowWidth: 350,
    windowLevel: 50,
  },
  {
    id: 4,
    name: 'preset_abdomen', 
    windowWidth: 400,
    windowLevel: 60,
  },
  {
    id: 5,
    name: 'preset_bones',
    windowWidth: 1500,
    windowLevel: 300,
  },
  {
    id: 6,
    name: 'preset_chest',
    windowWidth: 400,
    windowLevel: 40,
  },
  {
    id: 7,
    name: 'preset_angio',
    windowWidth: 600,
    windowLevel: 300,
  },
]

export const densityOptions = [
  {
  id: 1,
  name: 'Any',
  maxDensity: 2000,
  minDensity: -2000,
},{
  id: 2,
  name: 'Brain',
  maxDensity: 80,
  minDensity: 40,
},
{
  id: 3,
  name: 'Bones',
  maxDensity: 1500,
  minDensity: 145,
},
{
  id: 4,
  name: 'Mediastinum',
  maxDensity: 350,
  minDensity: 60,
},
{
  id: 5,
  name: 'Lungs',
  maxDensity: -450,
  minDensity: -1030,
}, 
{
  id: 6,
  name: 'Soft Tissue',
  maxDensity: 450,
  minDensity: 50,
} ]

export const zIndex = {
  moon: 'z-index: 9999',
  space: 'z-index: 999',
  sky: 'z-index: 99',
  hills: 'z-index: 9',
  floor: 'z-index: 0',
  underground: 'z-index: -9',
  bedrock: 'z-index: -99',
};

export const breakpoints = {
  iphone: {
    height: 480,
    width: 320,
  },
  iphoneSe: {
    height: 568,
    width: 320,
  },
  iphone8: {
    height: 667,
    width: 375,
  },
  iphonePlus: {
    height: 736,
    width: 414,
  },
  iphoneX: {
    height: 812,
    width: 414,
  },
  iphoneXR: {
    height: 896,
    width: 414,
  },
  ipad: {
    height: 1024,
    width: 768,
  },
  ipadLandscape: {
    height: 768,
    width: 1024,
  },
  hd: {
    height: 720,
    width: 1280,
  },
  wxgaPlus: {
    height: 900,
    width: 1440,
  },
  uxga: {
    height: 900,
    width: 1600,
  },
  fullHd: {
    height: 1080,
    width: 1920,
  },
};

const responsive = (orientation, minV, maxV, minS, maxS, withoutCalc) => {
  const a = roundToPrecision((maxV - minV) / (maxS - minS), 4);
  const b = roundToPrecision((maxS * minV - minS * maxV) / (maxS - minS), 4);

  return `${withoutCalc ? '' : 'calc'}(${a * 100}${orientation} + ${b}px)`;
};

export const functions = {
  responsive: {
    vh: (
      minValue,
      maxValue,
      minHeight = breakpoints.iphone.height,
      maxHeight = breakpoints.ipad.height
    ) => responsive('vh', minValue, maxValue, minHeight, maxHeight),
    vw: (
      minValue,
      maxValue,
      minWidth = breakpoints.iphone.width,
      maxWidth = breakpoints.fullHd.width
    ) => responsive('vw', minValue, maxValue, minWidth, maxWidth),
  },
  rgba: (hex, alpha) => {
    const h = hex.replace('#', '');
    let r = 0;
    let g = 0;
    let b = 0;
    const a = alpha >= 0 && alpha <= 1 ? alpha : 1;

    if (h.length === 3) {
      r = parseInt(`${h[0]}${h[0]}`, 16);
      g = parseInt(`${h[1]}${h[1]}`, 16);
      b = parseInt(`${h[2]}${h[2]}`, 16);
    } else if (h.length === 6) {
      r = parseInt(`${h[0]}${h[1]}`, 16);
      g = parseInt(`${h[2]}${h[3]}`, 16);
      b = parseInt(`${h[4]}${h[5]}`, 16);
    }

    if (
      Number.isInteger(r) &&
      Number.isInteger(g) &&
      Number.isInteger(b) &&
      r >= 0 &&
      r <= 255 &&
      g >= 0 &&
      g <= 255 &&
      b >= 0 &&
      b <= 255
    ) {
      return `rgba(${r}, ${g}, ${b}, ${a})`;
    }

    return 'rgba(0, 0, 0, 1)';
  },
  flattened: (hex, hexBackground, alpha) => {
    const h = hex.replace('#', '');
    const hBg = hexBackground.replace('#', '');
    let r = 0;
    let g = 0;
    let b = 0;
    let rBg = 0;
    let gBg = 0;
    let bBg = 0;
    const a = alpha >= 0 && alpha <= 1 ? alpha : 1;

    if (h.length === 3) {
      r = parseInt(`${h[0]}${h[0]}`, 16);
      g = parseInt(`${h[1]}${h[1]}`, 16);
      b = parseInt(`${h[2]}${h[2]}`, 16);
    } else if (h.length === 6) {
      r = parseInt(`${h[0]}${h[1]}`, 16);
      g = parseInt(`${h[2]}${h[3]}`, 16);
      b = parseInt(`${h[4]}${h[5]}`, 16);
    }

    if (hBg.length === 3) {
      rBg = parseInt(`${hBg[0]}${hBg[0]}`, 16);
      gBg = parseInt(`${hBg[1]}${hBg[1]}`, 16);
      bBg = parseInt(`${hBg[2]}${hBg[2]}`, 16);
    } else if (hBg.length === 6) {
      rBg = parseInt(`${hBg[0]}${hBg[1]}`, 16);
      gBg = parseInt(`${hBg[2]}${hBg[3]}`, 16);
      bBg = parseInt(`${hBg[4]}${hBg[5]}`, 16);
    }

    r = parseInt(r * a + rBg * (1 - a), 10);
    g = parseInt(g * a + gBg * (1 - a), 10);
    b = parseInt(b * a + bBg * (1 - a), 10);

    if (
      Number.isInteger(r) &&
      Number.isInteger(g) &&
      Number.isInteger(b) &&
      r >= 0 &&
      r <= 255 &&
      g >= 0 &&
      g <= 255 &&
      b >= 0 &&
      b <= 255
    ) {
      return `rgb(${r}, ${g}, ${b})`;
    }

    return 'rgb(0, 0, 0)';
  },
};

export const fontFamily = {
  sourceSansPro: {
    regular: css`
      font-family: SourceSansPro;
      font-weight: normal;
      font-style: normal;
    `,
    regularItalic: css`
      font-family: SourceSansPro;
      font-weight: normal;
      font-style: italic;
    `,
    bold: css`
      font-family: SourceSansPro;
      font-weight: bold;
      font-style: normal;
    `,
    boldItalic: css`
      font-family: SourceSansPro;
      font-weight: bold;
      font-style: italic;
    `,
  },
};

export const aspectRatio = {
  ratio1To1: css`
    padding-top: 100%;
    width: 100%;
  `,
  ratio3To4: css`
    padding-top: 133.33%;
    width: 100%;
  `,
  ratio4To3: css`
    padding-top: 75%;
    width: 100%;
  `,
  ratio9To16: css`
    padding-top: 177.78%;
    width: 100%;
  `,
  ratio16To9: css`
    padding-top: 56.25%;
    width: 100%;
  `,
};
